import { Container, spine } from "pixi.js";
import { SpineConst } from "../../../Constants/SpineConst";
import { GameModel } from "../../../Models/GameModel";
import { SpineContainer } from "../../Common/SpineContainer";

export const PoliceAnims = {
    idle: "idle",
    left1: "left_1",
    left2: "left_2",
    right1: "right_1",
    right2: "right_2",
}

export class PoliceSpine extends SpineContainer{
   constructor(index: number, model: GameModel){
       super(model, Object.values(PoliceAnims), index ? SpineConst.PoliceFord : SpineConst.PoliceVaz);
       this.setAnimation(PoliceAnims.idle, true);
   }
}